import { RouteConfig } from 'vue-router';
import hasd from './views/hasd.vue';
export const xsyxRouters: RouteConfig[] = [];

xsyxRouters.push({
  path: '/main/home/beforeHome',
  name: 'BeforeHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/home/BeforeHome.vue'),
  meta: { name: '首页', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/home/xsyxhome',
  name: 'XsyxHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/home/XsyxHome.vue'),
  meta: { name: '首页', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/userInfo',
  name: 'UserInfo',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/user/UserInfo.vue'),
  meta: { name: '我的', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/register',
  name: 'Register',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/user/Register.vue'),
  meta: { name: '注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/update/:id',
  name: 'UpdateUser',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/user/UpdateUser.vue'),
  meta: { name: '修改用户信息', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/coupon/getCoupon/:orgid&:phone&:activityid&:randomid&:sysUserId&:sysUserPhone',
  name: 'GetCoupon',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/coupon/GetCoupon.vue'),
  meta: { name: '领券', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/registerFromCoupon/:orgid&:phone&:activityid&:randomid&:sysUserId&:sysUserPhone',
  name: 'RegisterFromCoupon',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/RegisterFromCoupon.vue'
    ),
  meta: { name: '注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/coupon/getCouponResult/:orgid&:phone&:activityid&:randomid&:sysUserId&:useropenid&:sysUserPhone',
  name: 'GetCouponResult',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/coupon/GetCouponResult.vue'
    ),
  meta: { name: '领券结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/coupon/getCouponResult498',
  name: 'getCouponResult498',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/coupon/GetCouponResult498.vue'
    ),
  meta: { name: '领券结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/coupon/couponList',
  name: 'CouponList',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/coupon/CouponList.vue'),
  meta: { name: '领券记录', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/signup/signupList',
  name: 'SignupList',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/signup/SignupList.vue'),
  meta: { name: '活动专区', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/coupon/getCouponFromNotify/:activityid&:source',
  name: 'GetCouponFromNotify',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/coupon/GetCouponFromNotify.vue'
    ),
  meta: { name: '抽奖', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/registerFromCouponNotify/:activityid&:source',
  name: 'RegisterFromCouponNotify',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/RegisterFromCouponNotify.vue'
    ),
  meta: { name: '注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/coupon/getCouponFromNotifyResult',
  name: 'getCouponFromNotifyResult',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/coupon/GetCouponFromNotifyResult.vue'
    ),
  meta: { name: '抽奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/coupon/getCouponFromNotifyResult498',
  name: 'getCouponFromNotifyResult498',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/coupon/GetCouponFromNotifyResult498.vue'
    ),
  meta: { name: '抽奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/raffle/followRaffle',
  name: 'FollowRaffle',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/followraffle/FollowRaffle.vue'
    ),
  meta: { name: '抽奖', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/raffle/followRaffleHome',
  name: 'FollowRaffleHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/followraffle/FollowRaffleHome.vue'
    ),
  meta: { name: '抽奖', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/merchant/merchantCouponHome/:merchantQrinfId',
  name: 'MerchantCouponHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/merchant/MerchantCouponHome.vue'
    ),
  meta: { name: '扫码领好礼', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/merchant/merchantRaffle/:merchantQrinfId&:phonenum',
  name: 'MerchantRaffle',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/merchant/MerchantRaffle.vue'
    ),
  meta: { name: '扫码领好礼', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/merchant/merchantRaffleQuery',
  name: 'MerchantRaffleQuery',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/merchant/MerchantRaffleQuery.vue'
    ),
  meta: { name: '抽奖记录', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/scan/scan',
  name: 'scan',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/scan/scan.vue'),
  meta: { name: '导航', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/merchant/merchantAwarding/:merchantRaffleId&:merchantAwardingQRId&:randomid&:sysUserId&:sysUserPhone&:orgid',
  name: 'merchantAwarding',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/merchant/MerchantAwarding.vue'
    ),
  meta: { name: '兑奖', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/registerFromMerchantRaffle/:merchantRaffleId&:merchantAwardingQRId&:randomid&:sysUserId&:sysUserPhone&:orgid',
  name: 'RegisterFromMerchantRaffle',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/RegisterFromMerchantRaffle.vue'
    ),
  meta: { name: '注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/merchant/merchantAwardingMaterialObject/:merchantRaffleId&:merchantAwardingQRId',
  name: 'MerchantAwardingMaterialObject',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/merchant/MerchantAwardingMaterialObject.vue'
    ),
  meta: { name: '兑奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/merchant/merchantAwardingCoupon/:orgid&:phone&:activityid&:randomid&:sysUserId&:useropenid&:sysUserPhone&:merchantRaffleId&:merchantAwardingQRId',
  name: 'MerchantAwardingCoupon',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/merchant/MerchantAwardingCoupon.vue'
    ),
  meta: { name: '兑奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/merchant/merchantAwardingCoupon498',
  name: 'MerchantAwardingCoupon498',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/merchant/MerchantAwardingCoupon498.vue'
    ),
  meta: { name: '兑奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/userInfoMerchant',
  name: 'UserInfoMerchant',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/UserInfoMerchant.vue'
    ),
  meta: { name: '我的(商户)', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/recommend/merchantRecommendHome/:merchantcode',
  name: 'MerchantRecommendHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/recommend/MerchantRecommendHome.vue'
    ),
  meta: { name: '我的推荐', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/recommend/beforeMerchantRecommendHome',
  name: 'BeforeMerchantRecommendHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/recommend/BeforeMerchantRecommendHome.vue'
    ),
  meta: { name: '我的推荐', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/rights/rightsHomeInit',
  name: 'RightsHomeInit',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/rights/RightsHomeInit.vue'
    ),
  meta: { name: '权益', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/sign/bdhdSign/:orgid&:userid',
  name: 'BdhdSign',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/sign/BdhdSign.vue'),
  meta: { name: '爆点活动签到', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/registerFromBdhd/:orgid&:userid',
  name: 'RegisterFromBdhd',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/RegisterFromBdhd.vue'
    ),
  meta: { name: '爆点活动签到注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/sign/bdhdUnregistered',
  name: 'BdhdUnregistered',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/sign/BdhdUnregistered.vue'
    ),
  meta: { name: '扫码关注', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/ttczzf/ttczzfHome',
  name: 'TtczzfHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/ttczzf/TtczzfHome.vue'),
  meta: { name: '天天抽，周周支付有好礼', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/ttczzf/ttczzfRaffle',
  name: 'TtczzfRaffle',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/ttczzf/TtczzfRaffle.vue'
    ),
  meta: { name: '天天抽，周周支付有好礼', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/kjsmch/getKjsmchCoupon/:activityid',
  name: 'GetKjsmchCoupon',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/kjsmch/GetKjsmchCoupon.vue'
    ),
  meta: { name: '睡眠客户激活有礼', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/registerFromCouponKjsm/:activityid',
  name: 'RegisterFromCouponKjsm',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/RegisterFromCouponKjsm.vue'
    ),
  meta: { name: '注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/registerFromTtczzf',
  name: 'RegisterFromTtczzf',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/RegisterFromTtczzf.vue'
    ),
  meta: { name: '注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/syd/sydHome',
  name: 'SydHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/syd/SydHome.vue'),
  meta: { name: '苏邮豆', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/syd/sydAwardingHome',
  name: 'SydAwardingHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/syd/SydAwardingHome.vue'
    ),
  meta: { name: '苏邮豆兑奖中心', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/syd/sydAwardingDetail/:activityid',
  name: 'SydAwardingDetail',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/syd/SydAwardingDetail.vue'
    ),
  meta: { name: '苏邮豆兑奖中心', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/syd/sydCouponResult/:activityid',
  name: 'SydCouponResult',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/syd/SydCouponResult.vue'
    ),
  meta: { name: '苏邮豆兑奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/syd/sydCouponResult498',
  name: 'SydCouponResult498',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/syd/SydCouponResult498.vue'
    ),
  meta: { name: '苏邮豆兑奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/xjqy/xjqyHome',
  name: 'XjqyHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/xjqy/XjqyHome.vue'),
  meta: { name: '星级权益', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/xjqy/xjqyAwardingDetail/:activityid',
  name: 'XjqyAwardingDetail',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/xjqy/XjqyAwardingDetail.vue'
    ),
  meta: { name: '星级权益兑奖中心', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/xjqy/xjqyCouponResult/:activityid',
  name: 'XjqyCouponResult',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/xjqy/XjqyCouponResult.vue'
    ),
  meta: { name: '星级权益兑奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/xjqy/xjqyCouponResult498',
  name: 'XjqyCouponResult498',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/xjqy/XjqyCouponResult498.vue'
    ),
  meta: { name: '星级权益兑奖结果', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/xjqy/xjqyRaffleQuery',
  name: 'XjqyRaffleQuery',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/xjqy/XjqyRaffleQuery.vue'
    ),
  meta: { name: '星级权益兑奖信息列表', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/shdb/shdbCoupon/:activityid',
  name: 'ShdbCoupon',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/shdb/ShdbCoupon.vue'),
  meta: { name: '商户达标有礼', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/registerFromCouponShdb/:activityid',
  name: 'RegisterFromCouponShdb',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/RegisterFromCouponShdb.vue'
    ),
  meta: { name: '注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/ydsq/merchantList',
  name: 'MerchantList',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/ydsq/MerchantList.vue'),
  meta: { name: '附近商户列表', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/ydsq/merchantDetail/:id',
  name: 'MerchantDetail',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/ydsq/MerchantDetail.vue'
    ),
  meta: { name: '附近商户详情', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/signup/hdqrcode',
  name: 'Hdqrcode',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/signup/Hdqrcode.vue'),
  meta: { name: '二维码', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/nyjwsl/nyjwslCoupon/:activityid',
  name: 'NyjwslCoupon',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/nyjwsl/NyjwslCoupon.vue'
    ),
  meta: { name: '你引荐我送礼', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/user/registerFromCouponAll/:activityid',
  name: 'RegisterFromCouponAll',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/user/RegisterFromCouponAll.vue'
    ),
  meta: { name: '注册', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/error/dxpqError/:msg',
  name: 'DxpqError',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/error/DxpqError.vue'),
  meta: { name: '提示页面', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/txyl/txylCoupon/:activityid',
  name: 'TxylCoupon',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/txyl/TxylCoupon.vue'),
  meta: { name: '提现有礼', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/yhffl/yhfflHome/:activityid',
  name: 'YhfflHome',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/yhffl/YhfflHome.vue'),
  meta: { name: '邮惠翻翻乐', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/yhffl/yhfflToNavigation',
  name: 'YhfflToNavigation',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/yhffl/YhfflToNavigation.vue'
    ),
  meta: { name: '邮惠翻翻乐导航', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/yhffl/yhfflToPbQRcode',
  name: 'YhfflToPbQRcode',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/yhffl/YhfflToPbQRcode.vue'
    ),
  meta: { name: '邮惠翻翻乐手机银行二维码', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/yhffl/yhfflToYMT',
  name: 'YhfflToYMT',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(/* webpackChunkName: "demo" */ '@/views/main/yhffl/YhfflToYMT.vue'),
  meta: { name: '邮惠翻翻乐一码通', auth: 'true' },
});

xsyxRouters.push({
  path: '/main/yhffl/yhfflToChoose',
  name: 'YhfflToChoose',
  // route level code-splitting
  // this generates a separate chunk (about.[hash].js) for this route
  // which is lazy-loaded when the route is visited.
  component: () =>
    import(
      /* webpackChunkName: "demo" */ '@/views/main/yhffl/YhfflToChoose.vue'
    ),
  meta: { name: '邮惠翻翻乐借记卡', auth: 'true' },
});
